import React from 'react'
import { Link as RouterLink } from 'react-router-dom'

// components
import Typography from '@mui/material/Typography'
import Link from '@mui/material/Link'

const Notification = props => {
  const {
    color,
    basename,
    notification: { id, linkTo, linkToBasename, linkToTarget, title }
  } = props

  const paddingY = 0.5

  if (linkTo) {
    if (linkToBasename !== basename) {
      return (
        <Link
          py={paddingY}
          key={id}
          display='block'
          color={color}
          fontWeight='fontWeightBold'
          textDecoration='underline'
          href={`${linkToBasename}${linkTo}`}
          target={linkToTarget ? '_blank' : '_self'}
        >
          {title} »
        </Link>
      )
    } else {
      return (
        <Link
          py={paddingY}
          key={id}
          display='block'
          color={color}
          fontWeight='fontWeightBold'
          component={RouterLink}
          to={linkTo}
        >
          {title} »
        </Link>
      )
    }
  } else {
    return (
      <Typography
        color={color}
        py={paddingY}
        key={id}
        fontWeight='fontWeightBold'
      >
        {title}
      </Typography>
    )
  }
}

export default Notification
